import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

async function fetchMe() {
  try {
    return (await api.get("/auth/me")).data;
  } catch (e) {
    if (e.response?.status !== 401) throw e;
    await api.post("/auth/refresh");
    return (await api.get("/auth/me")).data;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const me = await fetchMe();
      setUser(me);
      return me;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    // Skip /me while returning from Google OAuth; AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) return;
    refreshUser();
  }, [refreshUser]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    return data;
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, refreshUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
